import TextField from "../../../../components/fields/textField/TextField.vue";
import PeriodoField from "../../../../components/fields/periodoField/PeriodoField.vue";
import TextAreaField from "../../../../components/fields/textAreaField/TextAreaField.vue";
import { AnalisarFeriasCivilService } from "../../../../services/AnalisarFeriasCivilService";
import OkayDialog from "../../../../components/dialog/okay/OkayDialog.vue"
import moment from "moment";
import { date, strtotime } from "date-typescript-library";
import { TiposFeriasEnum} from "../../../../constants";


export default {
  name: "AnalisarFerias",

  props: {
    selected: {
      required: true,
      default: [],
    },
    isOpen: {
      type: Boolean,
      required: true,
    }
  },

  components: {
    TextField,
    TextAreaField,
    PeriodoField,
    OkayDialog
  },

  data: () => ({
    id: null,

    form: {},
    titulo: 'Analisar Férias',
    textoDias: 'Número de Dias Úteis Solicitados',

    justificativaDialog: false,
    justificativa: "",


    confirmDialog:false,

    loading: {
      field: false,
      btnApprove: false,
      btnRefuse: false,
    }
  }),

  mounted() {
    this.id = this.selected.idFerias;
    if(this.selected.idTipo == TiposFeriasEnum['FERIAS_PREMIO']){
      this.titulo = 'Analisar Férias Prêmio'
      this.textoDias = 'Número de Dias Corridos Solicitados',
      this.limiteDias = 90;
    }

    if(this.$store.state.user.Civil){
      this.titulo = `Analisar Férias Civil ${this.selected.nome}`
    }
  },
    

  beforeMount(){
    this.getData(this.selected.idFerias);
    this.inicializarModal();
  },

  watch: {
    isOpen: function (isOpen) {
      if (isOpen) {
        this.getData(this.selected.idFerias);
        this.inicializarModal();
        
      }
    },
 
  },

  methods: {
    inicializarModal(){
      if(this.selected.idTipo == TiposFeriasEnum['FERIAS_PREMIO']){
        this.titulo = 'Analisar Férias Prêmio';
        this.textoDias = 'Número de Dias Corridos Solicitados';
      }else{
        this.titulo = 'Analisar Férias';
        this.numeroDiasTitulo = 'Número de dias úteis solicitados';
      }
    },
    async getData(id) {
      this.loading.field = true;
      const response = await AnalisarFeriasCivilService.getById(id);
      this.form = {
        dataInicioAnterior: response.data_ini,
        dataFimAnterior: response.data_fin,
        numeroDias: response.dias,
        exercicio: response.exercicio
      }
      const doisMeses = date("Y-m-d",strtotime("+ 2 MONTHS"));
      this.confirmDialog = doisMeses > moment(this.form.dataInicioAnterior).format("YYYY-MM-DD");
      this.loading.field = false;
      
    },

    async approve() {
      this.loading.btnApprove = true;
      const response = await AnalisarFeriasCivilService.aprovarFerias(this.selected.idFerias);
      this.loading.btnApprove = false;
      this.$emit('on-confirm');
      if (response) {
        this.close();
      }
    },

    prepareForm() {
      if (this.justificativa) {
        const formData = new FormData();
        formData.append("id_ferias", this.selected.idFerias);
        formData.append("justificativa_recusa_ferias", this.justificativa);
        this.refuse(formData);
      }
    },

    async refuse(formData) {
      this.loading.btnRefuse = true;
      const response = await AnalisarFeriasCivilService.recusarFerias(formData);
      if (response) {
        this.justificativaDialog = false;
        this.justificativa = null;
        this.$emit('on-confirm');
        this.close();
      }
      this.loading.btnRefuse = false;
    },

    close() {
      this.$emit("on-close");
    },
  },
};